export function setLicenseExpiresSoonCookie() {
    const thirtyDays = 30 * 24 * 60 * 60;

    document.cookie =
        "license_expires_soon=true" +
        "; max-age=" + thirtyDays +
        "; path=/" +
        "; SameSite=Lax";
}